import React from "react";
import {
  TrophyIcon,
  LightningIcon,
  DumbleIcon,
  PeopleIcon,
} from "../../../images/icons/icons";
import { useSelector } from "react-redux";

const AllGymOffersStats = () => {
  const { ongoingOffers} = useSelector((state) => state.plans);
  const TotalOffersCount = ongoingOffers?.data?.length || 0;
  const TotalActiveOffers = ongoingOffers?.data?.filter(
    (offer) => offer?.status === "active"
  ) || [];
  
  const TotalActiveOfferCount = TotalActiveOffers.length;
  const TotalInActiveOfferCount = TotalOffersCount - TotalActiveOfferCount;

  const statsData = [
    {
      icon: <TrophyIcon color="#fff" />,
      value: TotalActiveOfferCount,
      label: "Total Offers",
      bgColor: "#ef4444",
    },
    {
      icon: <LightningIcon color="#fff" />,
      value: TotalActiveOfferCount,
      label: "Active Offers",
      bgColor: "#22c55e",
    },
    {
      icon: <DumbleIcon color="#fff" />,
      value: TotalInActiveOfferCount,
      label: "Inactive Offers",
      bgColor: "#f59e0b",
    },
    {
      icon: <PeopleIcon color="#fff" />,
      value: "All",
      label: "Gym Locations",
      bgColor: "#f97316",
    },
  ];

  return (
    <div className="all-gym-offer-stats-section">
      {statsData.map((stat, index) => (
        <div key={index} className="all-gym-offer-stat-card">
          <div
            className="all-gym-offer-stat-icon"
            style={{ backgroundColor: stat.bgColor }}
          >
            {stat.icon}
          </div>
          <div className="all-gym-offer-stat-value">{stat.value}</div>
          <div className="all-gym-offer-stat-label">{stat.label}</div>
        </div>
      ))}
    </div>
  );
};

export default AllGymOffersStats;
